import api from "@/config/api";
import { log } from "@/utils/logger";
import { triggerFileDownload } from "@/utils/helpers";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Params } from "@/types/utils";
import useQueryAccountingTransactionsAttachments from "@/hooks/queries/useQueryAccountingTransactionsAttachments";

const useDownloadVerification = () => {
    const [loading, setLoading] = useState(false);
    const { fetchAccountingTransactionsAttachments } = useQueryAccountingTransactionsAttachments();

    const onDownload = async (options?: { pdf?: boolean }) => {
        try {
            setLoading(true);

            const data = await fetchAccountingTransactionsAttachments({ pdf: options?.pdf });
            if (!data) return;
            window.location.assign(data.url);
        } catch (e) {
            log.error(e);
        } finally {
            setLoading(false);
        }
    };
    return {
        downloading: loading,
        onDownload,
    };
};

const useRegistryExport = () => {
    const [downloading, setDownloading] = useState(false);
    const { oid, sid, rid } = useParams<Params>();

    const downloadRegistryExport = async (pages: string[], attachmentMd5s: string[]) => {
        try {
            setDownloading(true);
            const data = await api.post<{ blob: Blob; filename: string | null }>(
                `/organizations/${oid}/submissions/${sid}/reports/${rid}/registry-export`,
                { data: { pages, attachments: attachmentMd5s }, timeoutMs: 15 * 60000 },
            );

            const filename = data.filename || `rapport-${rid}-diarieforing.pdf`;
            const url = URL.createObjectURL(data.blob);
            triggerFileDownload({ url, filename });
            URL.revokeObjectURL(url);
        } catch (e) {
            log.error(e);
        } finally {
            setDownloading(false);
        }
    };

    return { downloading, downloadRegistryExport };
};

export { useDownloadVerification, useRegistryExport };
